
import 
	React, 
	{ 
		useEffect, 
		useState 
	} 								from 'react';

import { 
	GoogleAuthProvider, 
	signInWithPopup,
	getAuth,
	signInWithEmailAndPassword,
	setPersistence, 
	browserLocalPersistence
}									from 'firebase/auth';

import { useAuthState } 			from "react-firebase-hooks/auth";
import { auth } 					from '../utils/firebase';
import {
	useLocation,
	useNavigate
} 									from 'react-router-dom';

// - tbv Material UI (gebruik ik nu niet meer)
// import Button from '@mui/material/Button';

// [ ] icons implementeren 
import { FcGoogle } 				from "react-icons/fc";
// import { AiFillFacebook } from "react-icons/ai";




export default function Login() {

	const navigate 							= useNavigate();
	const location 							= useLocation();
	const state 							= location.state || {};

	const [user, loading] 					= useAuthState(auth);
	const googleProvider 					= new GoogleAuthProvider();

	const [credentials, setCredentials] 	= useState({email: "", password: ""});
	const [errorMessage, setErrorMessage] 	= useState('');


	const GoogleLogin = async () => {

		try {

			const result = await signInWithPopup(auth,googleProvider);

			// In case of pending order:
			if( state.retryOrderConfig ){

				navigate(
					'/product/'+state.retryOrderConfig.courseId, 
					{ 
						state: { 
							course: 			state.retryOrderConfig.course,
							retryOrderConfig:	state.retryOrderConfig
						} });

				return;
			}

			// Standard redirect
			navigate('/');
		}
		catch(error){
			// switch (error.code) {
			// 	case 'auth/email-already-in-use':
			// 		setErrorMessage('This email is already in use. Please try to login.');
			// 		break;
			// 	case 'auth/weak-password':
			// 		setErrorMessage('Weak password, choose a stronger password');
			// 		break;
			// 	case 'auth/invalid-email':
			// 		setErrorMessage('This is not a valid email address');
			// 		break;
			// 	case 'auth/operation-not-allowed':
			// 		setErrorMessage('Registration is currently disabled, please contact our support');
			// 		break;
			// 	default:
			// 		setErrorMessage('Something went wrong, please try again');
			// 		break;
			// }
		}
	}


	
	const loginWithEmailAndPassword		= async ()=>{
		
		const auth = getAuth();

		try {

			await setPersistence(auth, browserLocalPersistence)


			const result = await signInWithEmailAndPassword(auth, credentials.email, credentials.password);

			// In case of pending order:
			if( state.retryOrderConfig ){

				navigate(
					'/product/'+state.retryOrderConfig.courseId, 
					{ 
						state: { 
							course: 			state.retryOrderConfig.course,
							retryOrderConfig:	state.retryOrderConfig
						} });

				return;
			}

			return result;
		}
		catch(error){
		
			switch (error.code) {
				// case 'auth/email-already-in-use':
				// 	setErrorMessage('This email is already in use. Please try to login.');
				// 	break;
				// case 'auth/weak-password':
				// 	setErrorMessage('Weak password, choose a stronger password');
				// 	break;
				case 'auth/invalid-email':
					setErrorMessage('This is not a valid email address');
					break;
				case 'auth/invalid-login-credentials':
					setErrorMessage('Email or password is not correct');
					break;
				// case 'auth/operation-not-allowed':
				// 	setErrorMessage('Registration is currently disabled, please contact our support');
				// 	break;
				default:
					setErrorMessage('Something went wrong, please try again');
					break;
			}
		}
	}



	useEffect(() => {
		if (user) {
			navigate('/');
		}
	}, [user]);

	
	return (

		// 	<div className="flex flex-col gap-4">
		// 		<button 
		// 			className="text-white bg-gray-700 p-4 w-full font-medium rounded-lg flex align-middle gap-4"
		// 			onClick={GoogleLogin}
		// 		> 
		// 			<FcGoogle className="text-2xl"/>
		// 			Sign in with Google
		// 		</button>
		// 		{/* <button>Sign in with Facebook</button> */}
		// 	</div>
		// </div>

		<div>
			<div className="auth-header-spacing">
				{/* Login */}

				{
					state.retryOrderConfig

					? 
					
					<div>
						<h3>Login to complete the order</h3>
					</div>
					
					: null
				}
			</div>


			<div className="auth-form-wrapper">

				 <div className="form-container">

					<input
						className="text-input"
						value={credentials.email}
						type="email"
						placeholder="Please enter your e-mail address"
						onChange={event => setCredentials({ ...credentials, email: event.target.value })}
					/>

					<input
						className="text-input"
						value={credentials.password}
						type="password"
						placeholder="Enter your password"
						onChange={event => setCredentials({ ...credentials, password: event.target.value })}
					/>

					<button
						className="form-button"
						onClick={loginWithEmailAndPassword}
					>
						Login
					</button>

					<div className="auth-error-wrapper">
						{errorMessage && <p className="error-message">{errorMessage}</p>}
					</div>

					<p 
						onClick		= { ()=> {navigate( "/passwordReset")}}
						className	= "auth-link"
					>
						Forgot password
					</p>
				</div>
			</div>



			<div className="divider-container">
				<div className="line"></div>
				<p>or</p>
				<div className="line"></div>
			</div>

			<div className="auth-social-container">

				<button 
					className="google-login-btn"
					onClick={GoogleLogin}
				>
					<FcGoogle />
					Login with Google
				</button>
			</div>

			<br></br>

			<div className="auth-footer-text">
					<p 
					
						onClick 					= { ()=> {navigate( "/signup", { state: state })}}
						className					= "auth-link"
					>
						No account? Sign up here
					</p>
			</div>
		</div>
	);
}